import React, { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { sendToVercelAnalytics } from "./vitals";
import { initFeatureFlags } from "./services/featureFlags";
import "./globals.css";

// Kick off the Remote Config fetch at startup. Non-blocking: the app renders
// immediately with flag defaults and re-renders via useSyncExternalStore once
// values resolve (and again once the user context / custom signals are set).
initFeatureFlags();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

reportWebVitals(sendToVercelAnalytics);
